import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const CredentialRowSchema = z
  .object({
    id: z.number(),
    deploymentId: z.number(),
    type: z.string(),
    value: z.string(),
  })
  .loose();

export type CredentialRow = z.output<typeof CredentialRowSchema>;

export function getCredentialCollectionForDeployment(accountId: string, deploymentId: string) {
  return new RemoteCollection(`/api/account/${accountId}/deployment/${deploymentId}/credential`, CredentialRowSchema, CredentialRowSchema);
}
